'use client'

import type { ImageLoaderProps } from 'next/image'
import { cloudflareLoader } from '@mc/image-cloudflare'

export default function imageLoader(params: ImageLoaderProps) {
  return cloudflareLoader(params)
}
